import { ResumeBuilderCore } from "@/components/resume/ResumeBuilderCore";
import { ShareButton } from "@/components/common/ShareButton";

export default function ResumeBuilderPage() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-medium px-3 py-1">
            100% Free · No sign-up required to start
          </span>
          <h1 className="text-3xl sm:text-4xl font-heading font-semibold tracking-tight mt-3">Free Resume Builder</h1>
          <p className="text-muted-foreground mt-1 max-w-xl">
            Build a professional resume with live preview and PDF download. Works for freshers and experienced professionals — empty sections hide automatically.
          </p>
        </div>
        <ShareButton
          url={`${window.location.origin}/resume-builder`}
          text="Create your FREE professional resume with Udhyog Tech:"
          testIdPrefix="resume-builder-share"
          label="Share this tool"
          className="shrink-0"
        />
      </div>
      <ResumeBuilderCore />
    </div>
  );
}
